import { apiAbortController, Response } from '@ui/src';
import api from '../../../api/api';
import { ProfitLoss } from '../types';

export const profitLossApi = api.injectEndpoints({
  endpoints: (build) => ({
    getProfitLossReport: build.query<{ data: ProfitLoss }, string>({
      query: (query) => ({
        url: `/v1/reports/profit-loss${query}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    exportProfitLossSheet: build.query<string, string>({
      query: (query) => ({
        url: `/v1/reports/profit-loss?format=csv${query}`,
        responseHandler: (response) => response.text(),
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    exportProfitLossReport: build.mutation<
      any,
      { createdAtFrom?: string; createdAtTo?: string }
    >({
      query: (body) => ({
        url: '/v1/reports/profit-loss/export',
        method: 'POST',
        body,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    exportProfitLossReportWithAccounts: build.mutation<
      any,
      { createdAtFrom?: string; createdAtTo?: string }
    >({
      query: (body) => ({
        url: '/v1/reports/profit-loss/accounts/export',
        method: 'POST',
        body,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getReportsSettings: build.query<
      Response<{ key: string; data: { value: string } }>,
      void
    >({
      query: () => ({
        url: '/v1/settings?take=9999',
        signal: apiAbortController.getSignalToken(),
      }),
    }),
  }),
});

export const {
  useLazyGetProfitLossReportQuery,
  useLazyExportProfitLossSheetQuery,
  useExportProfitLossReportMutation,
  useExportProfitLossReportWithAccountsMutation,
  useLazyGetReportsSettingsQuery,
} = profitLossApi;

export const {
  endpoints: {
    getProfitLossReport,
    exportProfitLossSheet,
    exportProfitLossReport,
    exportProfitLossReportWithAccounts,
    getReportsSettings,
  },
} = profitLossApi;
